import React, { useState } from 'react'
import './billingSubscription.scss'
import { Row, Col } from 'react-bootstrap'
import ChoosePlanPopup from './component/ChoosePlanPopup'
import CurrentPlan from './component/CurrentPlan'
import SummarySubscription from './component/SummarySubscription'
import { onBoardingChangeAddOnsPreviewApi, onBoardingChangePlanPreviewApi } from '../../../../constants/ApiConfigs'
import { connect } from 'react-redux'
import { callApiWithoutDispatch } from '../../../../utils/apiUtils'
import PropTypes from 'prop-types'
import * as loadingActions from '../../../../actions/loadingBarActions'
import { bindActionCreators } from 'redux'
import UpdateSubscription from './component/UpdateSubscription'
import AddOns from './component/AddOns/AddOns'
import UpdateAddOns from './component/UpdateAddOns'
import TermPolicy from '../../../../features/signup/components/TermPolicy'
const BillingSubscription = ({
	billingUsage = {},
	auth = {},
	handleLoadBillingUsage,
	loadingActions,
	permissions,
	...props
}, context) => {
	const [newBillingPlan, setNewBillingPlan] = useState(billingUsage || {})
	const [previewBillingPlan, setPreviewBillingPlan] = useState(null)
	const [isShowUpdateSubscription, setIsShowUpdateSubscription] = useState(false)

	const [isShowUpdateAddOns, setIsShowUpdateAddOns] = useState(false);
	const [dataPreviewAddOns, setDataPreviewAddOns] = useState(null);
	const [addOnsRemovedAddedIds, setAddOnsRemovedAddedIds] = useState({
		removedAddOnIds: [],
		addOnIds: [],
	})
	
	const resetWhenChangePlanSuccess = () => {
		setIsShowUpdateSubscription(false)
		setPreviewBillingPlan(null)
		setNewBillingPlan(null)
	}

	const resetPreviewBillingPlan = () => {
		setIsShowUpdateSubscription(false)
		setPreviewBillingPlan(null)
		setNewBillingPlan(billingUsage)
	}

	const resetPreviewAddOns = () => {
		setIsShowUpdateAddOns(false)
		setDataPreviewAddOns(null)
	}

	const handleWhenNewBillingPlanChange = async (newPlan, removedAddOnIdsParam, addOnIdsParam) => {
		const removedAddOnIds = removedAddOnIdsParam || addOnsRemovedAddedIds.removedAddOnIds || []
		const addOnIds = addOnIdsParam || addOnsRemovedAddedIds.addOnIds || []
		if (
			(newPlan?.billingType !==
				billingUsage?.billingType) ||
			(newPlan?.planId !==
				billingUsage?.planId)
		) {
			loadingActions.showLoadingSpiner()
			try {
				const previewBillingPlan = await callApiWithoutDispatch(onBoardingChangePlanPreviewApi, {
					method: 'POST',
					body: JSON.stringify({
						fleetId: auth?.selectedFleet?.fleetId,
						planId: newPlan?.planId,
						billingType: newPlan?.billingType,
						removedAddOnIds,
						addOnIds,
					}),
				})
				if (previewBillingPlan?.res?.data) {
					setNewBillingPlan(newPlan)
					setPreviewBillingPlan(previewBillingPlan?.res?.data)
					setIsShowUpdateSubscription(true)
				} else {
					context.notification('error', 'Failed to get preview billing plan')
				}
			} catch (error) {
				context.notification('error', 'Failed to get preview billing plan')
			} finally {
				loadingActions.hideLoadingSpiner()
				resetPreviewAddOns()
			}
		}
	}

	const handleAddOnsChange = ({ removedAddOnIds, addOnIds }) => {
		setAddOnsRemovedAddedIds({
			removedAddOnIds: removedAddOnIds || [],
			addOnIds: addOnIds || [],
		})
		if (previewBillingPlan) {
			handleWhenNewBillingPlanChange(newBillingPlan, removedAddOnIds, addOnIds);
		} else {
			previewAddOns(removedAddOnIds, addOnIds);
		}
	}

	const previewAddOns = async (removedAddOnIds, addOnIds) => {
		loadingActions.showLoadingSpiner();
		try {
			const response = await callApiWithoutDispatch(onBoardingChangeAddOnsPreviewApi, {
				method: 'POST',
				body: JSON.stringify({
					fleetId: auth?.selectedFleet?.fleetId,
					removedAddOnIds,
					addOnIds,
				}),
			});
			if (response?.res?.data) {
				setIsShowUpdateAddOns(true);
				setDataPreviewAddOns({
					...response?.res?.data,
					addOnIds,
					removedAddOnIds,
				});
			} else {
				context.notification('error', 'Failed to preview add-ons');
			}
		} catch (error) {
			context.notification('error', 'Failed to preview add-ons');
		} finally {
			loadingActions.hideLoadingSpiner();
		}
	}

	return (
		<div className="billing-subscription-container">
			<Row>
				<Col sm={12} md={8}>
					<CurrentPlan
						billingUsage={billingUsage}
						newBillingPlan={newBillingPlan}
						onChangeNewBillingPlan={handleWhenNewBillingPlanChange}
						auth={auth}
						permissions={permissions}
						onResetPreviewBillingPlan={resetPreviewBillingPlan}
						onResetWhenChangePlanSuccess={resetWhenChangePlanSuccess}
						handleLoadBillingUsage={handleLoadBillingUsage}
					/>
					{
						billingUsage &&
						<AddOns
							billingUsage={billingUsage}
							auth={auth}
							context={context}
							loadingActions={loadingActions}
							handleLoadBillingUsage={handleLoadBillingUsage}
							onResetPreviewBillingPlan={resetPreviewBillingPlan}
							onAddOnsChange={handleAddOnsChange}
							onResetPreviewAddOns={resetPreviewAddOns}
							permissions={permissions}
						/>
					}
				</Col>
				<Col sm={12} md={4}>
					{
						isShowUpdateAddOns && dataPreviewAddOns ?
							<UpdateAddOns
								dataPreview={dataPreviewAddOns}
								loadingActions={loadingActions}
								onResetPreviewBillingPlan={resetPreviewBillingPlan}
								onResetPreviewAddOns={resetPreviewAddOns}
								handleLoadBillingUsage={handleLoadBillingUsage}
								auth={auth}
								context={context}
								billingUsage={billingUsage}
							/>
							: isShowUpdateSubscription ? (
								<UpdateSubscription
									newBillingUsage={newBillingPlan || billingUsage}
									previewBillingPlan={previewBillingPlan}
									previewAddOns={addOnsRemovedAddedIds}
									billingUsage={billingUsage}
									loadingActions={loadingActions}
									onResetPreviewBillingPlan={resetWhenChangePlanSuccess}
									handleLoadBillingUsage={handleLoadBillingUsage}
									context={context}
									auth={auth}
								/>
							) : (
								<SummarySubscription
									billingUsage={billingUsage}
									loadingActions={loadingActions}
									handleLoadBillingUsage={handleLoadBillingUsage}
									context={context}
									auth={auth}
									permissions={permissions}
								/>
							)
					}
					{
						((isShowUpdateAddOns && dataPreviewAddOns) || isShowUpdateSubscription) && (
							<TermPolicy
								isLightMode={false}
							/>
						)
					}
				</Col>
			</Row>
		</div>
	)
}

BillingSubscription.contextTypes = {
	notification: PropTypes.func,
}

function mapStateToProps(state) {
	return {
		auth: state.auth,
	}
}

function mapDispatchToProps(dispatch) {
	return {
		loadingActions: bindActionCreators(loadingActions, dispatch),
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(BillingSubscription);